module.exports = __webpack_public_path__ + "img/scholarly-kitchen.83c4826d.png";